// @symbo-ls/workspace-monaco — sharedLibrary context.
//
// Workspace surfaces that need the Monaco-backed code editor (canvas, the
// workspace shell, anywhere CodePreviewWidget is referenced by bare key)
// import this from their `sharedLibraries.js`. Surfaces that DON'T need
// monaco (analytics, design-system, marketplace, preview, the chrome-connect
// panel) stay free of the heavy editor + worker bundles.
//
// CodePreviewWidget lives here (rather than in @symbo-ls/workspace-shared)
// so workspace-shared doesn't drag monaco into every consumer's bundle —
// the widget's `await import('@symbo-ls/workspace-monaco')` only fires when
// the component actually renders.
import * as components from './components/index.js'

export default { components }
